"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieManagement = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_router_1 = require("react-router");
const zustandStore_1 = require("../../zustandStore");
const cookieDescription_1 = require("./cookieDescription");
const cookieOptions_1 = require("./cookieOptions");
const CookieManagement = () => {
    const { cookies, setIsCookieCutterOpen, togglePreferences, toggleStatistics, toggleMarketing } = (0, zustandStore_1.useZustand)(state => ({ ...state }));
    const { preferences, statistics, marketing } = cookies;
    const navigate = (0, react_router_1.useNavigate)();
    const handleCookieNoticeClick = (e) => {
        e.preventDefault();
        setIsCookieCutterOpen(false);
        void navigate('/cookie-notice');
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, spacing: 2, children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { size: 12, children: [(0, jsx_runtime_1.jsx)(cookieDescription_1.CookieDescription, { handleCookieNoticeClick: handleCookieNoticeClick }), (0, jsx_runtime_1.jsx)(cookieOptions_1.CookieOptions, { preferences: preferences, statistics: statistics, marketing: marketing, togglePreferences: togglePreferences, toggleStatistics: toggleStatistics, toggleMarketing: toggleMarketing, handleCookieNoticeClick: handleCookieNoticeClick })] }) }));
};
exports.CookieManagement = CookieManagement;
